<template>
  <vs-popup class="customer-bespoke-price-update-popup"
            title="VIEW/UPDATE CUSTOMER BESPOKE PRICE"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <template slot="actions">

      </template>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="update-bespoke-price-form" @submit.prevent="handleSubmit(onClickUpdateBespokePrice)" autocomplete="off">

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="formulation_code" name="formulation_code" rules="required" v-slot="{ errors }">
                <small class="label">ITS PRODUCT CODE</small>
                <vs-input disabled v-model="createForm.formulation_code" name="formulation_code" class="w-full" label=""
                          :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                          val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="formulation_name" name="formulation_name" rules="required" v-slot="{ errors }">
                <small class="label">ITS PRODUCT NAME</small>
                <vs-input disabled v-model="createForm.formulation_name" name="formulation_name" class="w-full" label=""
                          :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                          val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="customer_product_code" name="customer_product_code" rules="" v-slot="{ errors }">
                <small class="label">CUSTOMER PRODUCT CODE</small>
                <vs-input disabled v-model="createForm.customer_product_code" name="customer_product_code" class="w-full" label=""
                          :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                          val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <vs-button class="my-4" color="warning" @click.stop="is_logs_visible = !is_logs_visible">{{is_logs_visible ? 'Hide logs' : 'Show pricing logs'}}</vs-button>
          <vx-card title="Historical live pricing" cardBorder v-if="is_logs_visible">
            <vs-collapse accordion>
              <vs-collapse-item v-for="(prices_tier_history, index) in bespoke_price_history" :key="index+'1'">
                <div slot="header">
                  {{ prices_tier_history.date }}
                </div>
                <vx-card v-for="(record, index) in prices_tier_history.records" :key="record.time" :title="`Time: ${record.time}`" :subtitle="`Author: ${record.created_by && record.created_by.name ? record.created_by.name : 'N/A'}`" cardBorder noShadow class="mb-2">
                  <vs-list>
                  <vs-list-item class="flex items-center p-1 list-item mb-4" v-for="(prices_tier, index) in record.tiers" :key="index+'1'">
                    <div class="vx-row">
                      <table>
                        <tbody>
                        <tr>
                          <td>
                            <div class="vx-row px-4 mb-4 mr-2">
                                <vs-input label-placeholder="Quantity from (Kg)"  v-model="prices_tier.from" type="number" step="0.01" name="from" class="w-full" 
                                  val-icon-danger="icon-x" val-icon-pack="feather" readonly/>
                            </div>
                            <div class="vx-row px-4 mr-2 mb-4">
                              <vs-input label-placeholder="Quantity to (Kg)"  v-model="prices_tier.to" type="number" step="0.01" name="to" class="w-full"
                                  val-icon-danger="icon-x" val-icon-pack="feather" readonly/>
                            </div>
                          </td>
                          <td>
                            <div class="vx-row px-4 mb-4 mr-2">
                              <vs-input :label-placeholder="`Guide price from (${account_currency}/KG)`"
                                        readonly :value="prices_tier.guide_from" name="fromPrice" class="w-full"/>
                            </div>
                            <div class="vx-row px-4 mr-2 mb-4">
                              <vs-input :label-placeholder="`Guide price to (${account_currency}/KG)`"
                                        readonly :value="prices_tier.guide_to" name="toPrice" class="w-full"/>
                            </div>
                          </td>
                          <td>
                            <vs-input :label-placeholder="`Bespoke price (${account_currency}/KG)`" v-model="prices_tier.price" type="text" name="price" class="w-full"
                                        val-icon-danger="icon-x" val-icon-pack="feather" readonly/>
                          </td>
                          <td>
                            <div class="vx-row px-4 mb-4 mr-2">
                              <vs-input label-placeholder=" Gross Margin % "
                                        readonly :value="prices_tier.guide_from" type="text" name="fromPrice" class="w-full"/>
                            </div>
                            <div class="vx-row px-4 mr-2 mb-4">
                              <vs-input label-placeholder=" Gross Margin % "
                                        readonly :value="prices_tier.guide_to" name="toPrice" class="w-full"/>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                  </vs-list-item>
                </vs-list>
                </vx-card>
              </vs-collapse-item>
            </vs-collapse>
          </vx-card>

          <div class="vx-row mb-3">
            <div class="vx-col w-full text-center">
              <vs-alert :color="createForm.using_default_pricing ? 'warning' : 'primary'" class="h-auto font-bold">
                {{ createForm.using_default_pricing ? "M&F Pricing - This product uses standard costings" : "M&F Pricing - This product uses actual costings" }}
              </vs-alert>
            </div>
          </div>

          <vx-card no-shadow cardBorder title="Live pricing" class="my-4">
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-list>
          <!-- <draggable :list="createForm.tiers"> -->

            <!-- <transition-group> -->
              <vs-list-item class="mb-4" v-for="(prices_tier, index) in createForm.tiers" :key="index+'1'">
                <div class="vx-row">
                  <table>
                    <tbody>
                    <tr>
                      <td>
                        <div class="vx-row px-4 mb-4 mr-2">
                          <ValidationProvider :vid="index+'from'" :name="index+'from'" :rules="validate_prices_tier(index)"
                                              v-slot="{ errors }">
                            <vs-input readonly label-placeholder="Quantity from (Kg)"  v-model="prices_tier.from" type="number" step="0.01" name="from" class="w-full"
                                      :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                      val-icon-pack="feather"/>
                          </ValidationProvider>
                        </div>
                        <div class="vx-row px-4 mr-2 mb-4">
                          <ValidationProvider :vid="index+'to'" :name="index+'to'" :rules="validate_max_price_tier(index)"
                                              v-slot="{ errors }">
                            <vs-input readonly label-placeholder="Quantity to (Kg)"  v-model="prices_tier.to" type="number" step="0.01" name="to" class="w-full" :danger="!!errors[0]"
                                      :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                          </ValidationProvider>
                        </div>
                      </td>
                      <td>
                        <div class="vx-row px-4 mb-4 mr-2">
                          <vs-input :label-placeholder="`Guide price from (${account_currency}/KG)`"
                                    readonly :value="calculateProductListPrice(createForm.pe_g, prices_tier.from, createForm.fx_rate, is_shipping_cost_enable)" name="fromPrice" class="w-full"/>
                        </div>
                        <div class="vx-row px-4 mr-2 mb-4">
                          <vs-input :label-placeholder="`Guide price to (${account_currency}/KG)`"
                                    readonly :value="calculateProductListPrice(createForm.pe_g, prices_tier.to, createForm.fx_rate, is_shipping_cost_enable)" name="toPrice" class="w-full"/>
                        </div>
                      </td>
                      <td>
                        <ValidationProvider :vid="index+'price'" :name="index+'price'" rules="required" v-slot="{ errors }">
                          <vs-input readonly :label-placeholder="`Bespoke price (${account_currency}/KG)`" v-model="prices_tier.price" type="text" name="price" class="w-full" :danger="!!errors[0]"
                                    :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                        </ValidationProvider>
                      </td>
                      <td>
                        <div class="vx-row px-4 mb-4 mr-2">
                          <vs-input label-placeholder=" Gross Margin % "
                                    readonly :value="calculateGrossMargin(createForm.pe_g, prices_tier.from, prices_tier.price, is_shipping_cost_enable, createForm.fx_rate)" type="text" name="fromPrice" class="w-full"/>
                        </div>
                        <div class="vx-row px-4 mr-2 mb-4">
                          <vs-input label-placeholder=" Gross Margin % "
                                    readonly :value="calculateGrossMargin(createForm.pe_g, prices_tier.to, prices_tier.price, is_shipping_cost_enable, createForm.fx_rate)" name="toPrice" class="w-full"/>
                        </div>
                      </td>
                      <!-- <td>
                        <vs-button :disabled="createForm.tiers.length === 1" class="ml-3" @click="deletePriceTier(index)" size="small"
                                   color="danger" type="filled" icon-pack="feather" icon="icon-x"></vs-button>
                      </td>
                      <td>
                        <feather-icon icon="AlignJustifyIcon" class="cursor-pointer ml-4 mr-6 mt-1 w-8" />
                      </td> -->
                    </tr>
                    </tbody>
                  </table>
                </div>

              </vs-list-item>
            <!-- </transition-group> -->

          <!-- </draggable> -->
          </vs-list>
              </div>
            </div>
          </vx-card>


          <vx-card cardBorder class="pb-4" title="Draft pricing & Modeling new deels">
            <div class="flex">
              <vs-button @click="onClickModalPricing" color="success" type="filled" icon-pack="feather" class="ml-auto mr-0 float-right"
                        icon="icon-git-merge">Create/View model pricing
              </vs-button>
            </div>
            <div class="ml-auto mr-0 float-right text-warning mt-2">
                <span v-if="draft_pricing_count > 0">There are {{ draft_pricing_count }} pricing model(s) available.</span>
                <span v-else>No pricing models available.</span>
            </div>
          </vx-card>


          <div class="vx-row mb-3 mt-12">
            <div class="vx-col w-1/2">
              <ValidationProvider vid="note" name="note" rules="required" v-slot="{ errors }">
                <small class="label">Incoterm</small>
                <v-select :append-to-body="true"
                          calculatePosition="top" :clearable="true" name="incoterms" placeholder=""
                          v-model="createForm.incoterm"
                          label="code"
                          :reduce="option => option.code"
                          :options="incoterms" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/2" v-if="is_shipping_cost_enable">
              <br>
              <span class="text-danger">*Please note this incoterm will add shipping to your margin calculation above and will reduce margin compared to EXW</span> 
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                <small class="label">Note</small>
                <vs-textarea class="mb-0" v-model="createForm.note" height="100px"/>
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>


          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="onClickRemoveBespokePrice" class="mt-2 ml-2" color="danger">Remove bespoke price
            </vs-button>
            <vs-button @click="open = false" class="ml-4 mt-2" type="border" color="warning">Close</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
    <ModelPricingBepokePopUp 
      @setBespokeLivePrice="setBespokeLivePrice"
      @fetchDraftpricingList="refreshData"
      ref="modelPricingBepokePopUp" 
      :account_currency="account_currency"/>
  </vs-popup>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'

const CustomerRepository = RepositoryFactory.get('customer')
const IncotermRepository = RepositoryFactory.get('incoterm');

import vSelect from 'vue-select'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import Calculations from '@/mixins/Calculations'
import draggable from 'vuedraggable'

import ModelPricingBepokePopUp from '@/components/popups/customer/bespoke-price/ModelPricingBepokePopUp.vue'

function initialState() {
  return {
    open: false,
    incoterms: [],
    createForm: {
      tiers: [],
      using_default_pricing: false, 
    },
    id: '',
    bespoke_price_history: [],
    is_logs_visible: false,
    draft_pricing_count: 0
  }
}

export default {
  name: 'UpdateCustomerBepokePricePopUp',
  data() {
    return initialState()
  },
  props: {
    account_currency: {
      type: String,
      default: '',
    }
  },
  methods: {
    async openPopup(id) {
      try {
        Object.assign(this.$data, initialState())
        this.id = id
        this.open = true;
        await this.fetchBespokePriceDetails()
        await this.fetchBespokePriceHistory()
        await this.fetchIncoterms()
        await this.fetchDraftPricing()
      } catch (error) {

      }
    },
    async onClickUpdateBespokePrice() {
      const vue = this;
      await this.$vs.loading({
        container: `#update-bespoke-price-form`,
        scale: 0.45
      })
      try {
        let payload =  {}
        payload.incoterm = this.createForm.incoterm
        payload.note = this.createForm.note
        payload.tiers = this.createForm.tiers.map((n) => {
          return { from : n.from, to: n.to, price: Number(n.price).toFixed(2) }
        })
        payload.shipping_cost = this.is_shipping_cost_enable ?  Number(this.createForm.pe_g.rseq5).toFixed(2) : '0.00'
        await CustomerRepository.updateCustomerBespokePrice(this.id, payload)
        this.showSuccessMessage('Bespoke price updated successfully')
        await vue.$parent.refreshData()
        this.open = false;
      } catch (e) {
        this.$vs.loading.close(`#update-bespoke-price-form > .con-vs-loading`)
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close(`#update-bespoke-price-form > .con-vs-loading`)
    },
    async fetchIncoterms() {
      try {
        const {data} = (await IncotermRepository.getListOfIncoterms(1, '', 50, '')).data
        this.incoterms = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async onClickRemoveBespokePrice() {
      const vue = this;
      await this.$vs.loading({
        container: `#update-bespoke-price-form`,
        scale: 0.45
      })
      try {
        await CustomerRepository.removeCustomerBespokePrice(this.id)
        this.showSuccessMessage('bespoke price deleted successfully')
        await vue.$parent.refreshData()
        this.open = false;
      } catch (e) {
        this.$vs.loading.close(`#update-bespoke-price-form > .con-vs-loading`)
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async fetchBespokePriceDetails() {
      await this.$vs.loading({
        container: `#update-bespoke-price-form`,
        scale: 0.45
      })
      const {data} = await CustomerRepository.getBespokePriceDetails(this.id)
      this.createForm = data.data
      if(this.createForm.tiers.length === 0) {
        this.createForm.tiers.push({ from: null, to: null, price: null })
      }
      this.$vs.loading.close(`#update-bespoke-price-form > .con-vs-loading`)
    },
    async fetchBespokePriceHistory() {
      await this.$vs.loading({
        container: `#update-bespoke-price-form`,
        scale: 0.45
      });

      const { data } = (await CustomerRepository.getBespokePriceHistory(
        this.createForm.customer_id, 
        this.createForm.formulation_id
      )).data;

      data.forEach(record => {
        record.price = Number(record.price).toFixed(2);
      });

      this.bespoke_price_history = Object.values(data.reduce((acc, record) => {
        const date = this.__dateTimeFormatterToDate(record.created_at);
        const time = this.__dateTimeFormatterToTime(record.created_at);

        if (!acc[date]) {
          acc[date] = { date, records: [] };
        }

        let timeGroup = acc[date].records.find(group => group.time === time);
        if (!timeGroup) {
          timeGroup = { time, created_by: record.created_by, tiers: [] };
          acc[date].records.push(timeGroup);
        }

        timeGroup.tiers.push(record);

        return acc;
      }, {}));

      this.$vs.loading.close(`#update-bespoke-price-form > .con-vs-loading`);
    },
    projectBriefColorFactory(id) {
      switch (id) {
        case 1:
          return '#a0937d';
        case 2:
          return 'warning';
        case 3:
          return 'primary';
        case 4:
          return '#00adb5';
      }
    },
    validate_prices_tier(index) {
      let previousIndex = index - 1
      // return `min_than:@${index}to|cross_over_max:@${previousIndex}to|required`
      return `min_than_or_equal:@${index}to|cross_over_max_equal:@${previousIndex}to|required`
    },
    validate_max_price_tier(index) {
      // return `max_than:@${index}from|required`
      return `max_than_or_equal:@${index}from|required`
    },
    addPriceTier() {
      this.createForm.tiers.push(
        {from: null, to: null, price: null}
      )
    },
    onClickModalPricing() {
      this.$refs.modelPricingBepokePopUp.openPopup(this.id)
    },
    async setBespokeLivePrice(data) {
      this.createForm = data
      await this.onClickUpdateBespokePrice()
    },
    deletePriceTier(index) {
      this.createForm.tiers.splice(index, 1)
    },
    async fetchDraftPricing() {
      try {
        const { data } = (await CustomerRepository.getDraftBespokePriceList(150, this.createForm.customer_id, this.createForm.formulation_id)).data
        this.draft_pricing_count = data.length
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async refreshData() {
      await this.fetchBespokePriceHistory()
      await this.fetchDraftPricing()
    },
  },
  async mounted() {

  },
  computed: {
    is_shipping_cost_enable() {
      const find = this.incoterms.find((x) => this.createForm.incoterm === x.code)
      return find ? find.is_price_included : false
    }
  },
  components: {
    'v-select': vSelect,
    draggable,
    ModelPricingBepokePopUp
  },
  mixins: [SuccessMessage, ErrorMessages, Calculations],
}
</script>

<style scoped>
.stripped-table:nth-child(even) {
  background-color: #f1f8ff;
}
.customer-bespoke-price-update-popup >>> .vs-popup {
  /*min-height: 50% !important;*/
  min-width: 50% !important;
}

</style>
